<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import Qs from 'qs'
    let countryList = {};
    export default {
        name: 'country',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){
            this.$axios.post(URL.country.list).then(res => {
                console.log(res);
                for (let i in res.result) {
                    countryList[res.result[i].code] = res.result[i].nameCn;
                }
                this.$refs.childTable.defaultQueryData(this.queryData);
            })
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    row.country = row.country.split(",");
                    this.$refs.childUpdate.open(row);
                }else if (clickName == "delete"){
                    this.dataChanage(URL.team.delete,{id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('txmis.bt.add') == clickName){
                    this.$refs.childUpdate.open();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                model.country = model.country.join(",");
                //根据是否包含id更新还是添加
                this.dataChanage(URL.team.edit,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        {title: "id", field: 'id', hidden: true},
                        { title: window.$t('txmis.team.name'), field: 'name',required:true},
                        { title: window.$t('txmis.team.country'), field: 'country',optionList: countryList,type: 4,data:[],required:true},
                        { title: window.$t('txmis.team.utmSource'), field: 'utmSource',required:true},
                        { title: window.$t('txmis.team.utmMedium'), field: 'utmMedium',required:true},
                    ],
                },
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                      {click:window.$t('txmis.bt.search')},
                      {click:window.$t('txmis.bt.add')},
                  ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.team.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    isPage:false,
                    cols: [
                        { title: window.$t('txmis.team.name'), field: 'name'},
                        { title: window.$t('txmis.team.country'), field: 'country',render: (data, full) => {
                                let result = "";
                                let split = data.split(",");
                                for (let i in split) {
                                    result = result + "," + countryList[split[i]];
                                }
                                return result.slice(1);
                            }},
                        { title: window.$t('txmis.team.utmSource'), field: 'utmSource'},
                        { title: window.$t('txmis.team.utmMedium'), field: 'utmMedium'},
                       /* {field:window.$t('txmis.bt.edit'),title:window.$t('txmis.bt.operation'),size:"mini",click:"update",type:"primary",icon:"el-icon-edit"},
                        {field:window.$t('txmis.bt.delete'),title:window.$t('txmis.bt.operation'),size:"mini",click:"delete",type:"primary",icon:"el-icon-delete"},*/
                        {title:window.$t('txmis.bt.operation'),btnClick:[
                                {name:window.$t('txmis.bt.edit'),click:"update",type:"primary",icon: "el-icon-edit"},
                                {name:window.$t('txmis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"}
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>

